import { fetchAll } from '@/api/category';
import { toTree } from '@/utils/tree';
import types from '../types';

const state = {
  allCategories: [],
  categories: [],
  eventCategories: [],
  problemCategories: [],
  changeCategories: [],
  releaseCategories: [],
  knowledgeCategories: [],
  categorieTree: []
}

const mutations = {
  [types.SET_ALLCATEGORIES](state, allCategories) {
    state.allCategories = allCategories;
  },
  [types.SET_CATEGORIES](state, categories) {
    state.categories = categories;
    state.eventCategories = categories.filter(e => (e.categoryTypes || []).includes('doc_type_event'));
    state.problemCategories = categories.filter(e => (e.categoryTypes || []).includes('doc_type_problem'));
    state.changeCategories = categories.filter(e => (e.categoryTypes || []).includes('doc_type_change'));
    state.releaseCategories = categories.filter(e => (e.categoryTypes || []).includes('doc_type_release'));
    state.knowledgeCategories = categories.filter(e => (e.categoryTypes || []).includes('doc_type_knowledge'));
    state.categorieTree = toTree(categories);
  }
};

const actions = {
  fetchCategories({ commit }) {
    this.tableLoading = true;
    return fetchAll()
      .then(res => {
        const allCategories = (res.data.data || []).filter(e => String(e.id) !== '0').map(category => {
          return { ...category, disabled: category.status !== 'enable' };
        })
        const categories = allCategories.filter(e => e.status !== 'delete');
        commit(types.SET_ALLCATEGORIES, allCategories || [])
        commit(types.SET_CATEGORIES, categories || []);
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/modules/category.js